import { Box, Grid, SpaceBetween, Button } from "@cloudscape-design/components";

interface LegacyHeaderProps {
  openHelpPanel: (isOpen: boolean) => void;
}

// The original skyscraper header, kept verbatim as the public facing version
// while the new site is behind the preview flag.
export const LegacyHeader: React.FC<LegacyHeaderProps> = ({ openHelpPanel }) => {
  return (
    <Box data-testid="hero-header" padding={{ top: "xs", bottom: "l" }}>
      <Grid
        gridDefinition={[
          { colspan: { default: 12, xs: 8, s: 9 } },
          { colspan: { default: 12, xs: 4, s: 3 } },
        ]}
      >
        <div>
          <Box variant="h1">Skyscraper Data Demo Dashboard</Box>
          <Box
            variant="p"
            color="text-body-secondary"
            margin={{ top: "xxs", bottom: "s" }}
          >
            This site is a proof-of-skills project built to demonstrate
            interactive data visualization, layout customization, and upcoming
            live-update functionality. The data shown here is placeholder
            information and should not be treated as factual or complete.
          </Box>
          <SpaceBetween size="xs">
            <p>
              The side panel on the right side contains more information about
              the dashboard.
            </p>
            <div>
              If closed, click the blue icon to open the side panel{" "}
              <Button
                iconName="external"
                variant="inline-icon"
                onClick={() => openHelpPanel(true)}
              />
            </div>
          </SpaceBetween>
        </div>
      </Grid>
    </Box>
  );
};
